<template>
  <v-app>
    <div class="fox-loading-spinner">
      <v-progress-circular v-show="loading"
        indeterminate
        :size="70"
        :width="7"
        color="primary"
      ></v-progress-circular>
    </div>
    <v-container>
      <LogoRow/>
      <v-row>
        <v-col class="tw-text-center">
          <h1>Zahlung erfolgreich abgeschlossen</h1>
          <p class="tw-mt-4 tw-text-lg">
            Vielen Dank für dein Beitrag
          </p>
          <v-icon large color="green" class="tw-mt-4">mdi-check-circle</v-icon>
        </v-col>
      </v-row>
      <v-row class="tw-mt-10">
        <v-spacer/>
        <v-col cols="6">
          <div class="fox-success-message tw-text-center tw-pt-5 tw-pb-5 tw-rounded-3xl">
            <v-btn class="tw-mt-5 tw-text-white" elevation="2" color="rgba(255,77,0,0.9)" @click="goToDashboard">
              Zurück zum Dashboard
            </v-btn>
          </div>
        </v-col>
        <v-spacer/>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import LogoRow from '@/components/Common/LogoRow.vue'

export default {
  components: {
    LogoRow
  },
  data () {
    return {
      loading: false,
      sessionId: null
    }
  },
  methods: {
    goToDashboard () {
      this.$router.push('/dashboard')
    }
  }
}
</script>

<style scoped>
.fox-success-message {
  background-color: #f1f8f5;
  border: 1px solid #ccc;
}
</style>
